import React, { useEffect, useState, lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route, Outlet } from 'react-router-dom'; // Added Outlet here
import LoadingSpinner from './components/loadingspinner';
import './App.css';
import Termsandpolicies from './components/Termsandpolicies';

// Lazy loading the components
const StartUp = lazy(() => import('./components/StartUps'));

const FooterComponent = lazy(() => import('./components/footer'));
const LegalComponent = lazy(() => import('./components/legal'));
const NavBar = lazy(() => import('./components/navbar'));
const Upperbox = lazy(() => import('./components/Upperbox'));
const ReviewTestmonials = lazy(() => import('./components/reviews'));
const ServiceCan = lazy(() => import('./components/service'));
const Contactus = lazy(() => import('./components/contactus'));
const WhatsAppChatButton = lazy(() => import('./components/WhatsAppChatButton'));
const Scrolltop = lazy(() => import('./components/Scrolltop'));
const HomePage = lazy(() => import('./components/homepage'));
const Privacypolicy = lazy(() => import('./components/Privacypolicy'));
const Refundpolicy = lazy(() => import('./components/Refundpolicy'));
const Error404 = lazy(() => import('./components/Error404'));

const App = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 2000);

    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.register('/service-worker.js')
        .then((registration) => {
          console.log('Service Worker registered with scope:', registration.scope);
        })
        .catch((error) => {
          console.log('Service Worker registration failed:', error);
        });
    }
  }, []);

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <Router>
      <div className="App">
        <Suspense fallback={<LoadingSpinner />}>
          <Routes>
            <Route element={<>
              <Upperbox />
              <NavBar />
              <Outlet />
              <FooterComponent />
              <WhatsAppChatButton />
              <Scrolltop />
            </>}>
              <Route path="/" element={<HomePage />} />
              <Route path="/startups" element={<StartUp />} />
              
              <Route path="/legal" element={<LegalComponent />} />
              <Route path="/reviews" element={<ReviewTestmonials />} />
              <Route path="/service" element={<ServiceCan />} />
              <Route path="/contactus" element={<Contactus />} />
              <Route path="/privacypolicy" element={<Privacypolicy />} />
              <Route path="/refundpolicy" element={<Refundpolicy />} />
              <Route path="/terms" element={<Termsandpolicies />} />
            </Route>
            {/* 404 route - completely standalone */}
            <Route path="*" element={<Error404 />} />
          </Routes>
        </Suspense>
      </div>
    </Router>
  );
};

export default App;

